<template>
  <div class="main">
    <div v-show="loading" class="spinner is-loading"></div>
    <div class="overview" :class="{loading}">
      <Authorised />
      <Search />
      <div class="stores">
        <Type />
        <GoogleMap :lang="lang" />
        <div class="info">
          <Popup />
          <div></div> <!-- To keep the List at the bottom -->
          <List />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Authorised from './partials/Authorised'
  import GoogleMap from './partials/Map'
  import List from './partials/List'
  import Popup from './partials/Popup'
  import Search from './partials/Search'
  import Type from './partials/Type'

  export default {
    name: 'Index',
    props: ['lang'],
    components: {
      Authorised,
      GoogleMap,
      List,
      Popup,
      Search,
      Type
    },
    computed: {
      loading () {
        return this.$store.state.loading
      }
    }
  }
</script>

<style src="@/styles/spinner.scss" lang="scss"></style>

<style scoped>
  .spinner {
    z-index: 10000
  }
  .main {
    display: flex;
    flex-flow: column;
    flex: 1 1 auto;
  }
  .overview {
    display: flex;
    flex-flow: column;
    flex: 1 1 auto;
  }
  .overview.loading {
    filter: blur(3px) grayscale(100%);
    filter: gray;
  }
  .stores {
    height: 100%;
    flex: 1 1 auto;
    display: flex;
    flex-flow: column;
    position: relative;
  }
  .info {
    position: absolute;
    z-index: 10;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 70px 20px 20px;
    box-sizing: border-box;
    justify-content: space-between;
    width: 360px;
    max-width: 50%;
    pointer-events: none;
  }

  @media only screen and (max-device-width: 768px) {
    .info {
      position: relative;
      width: 100%;
      max-width: 100%;
      padding: 20px;
    }
    .stores {
      display: block;
    }
  }
</style>



// WEBPACK FOOTER //
// Index.vue?24846e6a